import { FigureDrawAction } from './figure-draw-action';
import { DrawAction, DrawActionElement, DrawOptions } from '../draw-action';

declare const fabric;

export class TriangleDrawAction extends FigureDrawAction {

    drawActionElement: DrawActionElement = DrawActionElement.TRIANGLE;

    createCanvasElement(options?: DrawOptions): any {

        let left = 10;
        let top = 10;
        const width = 40;
        const height = 40;
        let color = 'blue';
        let borderWidth = 2;

        if (options) {

            if (options.stampingPosition) {
                left = options.stampingPosition.x;
                top = options.stampingPosition.y;
            }

            if (options.color) {
                color = options.color.getColorString();
            }

            if (options.borderWidth) {
                borderWidth = options.borderWidth;
            }

        }

        let cornerSize = DrawAction.defaults.cornerSize;

        if (this.isTouchDevice()) {
            cornerSize *= 2;
        }

        const triangle = new fabric.Triangle({
            width,
            height,
            left: left - width / 2,
            top: top - height / 2,
            stroke: color,
            strokeWidth: borderWidth,
            fill: 'transparent',
            borderColor: DrawAction.defaults.borderColor,
            cornerColor: DrawAction.defaults.cornerColor,
            cornerSize,
            transparentCorners: DrawAction.defaults.transparentCorners
        });

        return triangle;
    }
}
